(function () {
  function addWeekLabel() {
    document.querySelectorAll('span.price').forEach(function (el) {
      if (!el.querySelector('.price-unit')) {
        var span = document.createElement('span');
        span.className = 'price-unit';
        span.textContent = ' / week';
        el.appendChild(span);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addWeekLabel);
  } else {
    addWeekLabel();
  }
})();

(function () {
  var url = window.ltbnChubStylesUrl;
  if (!url) return;

  /*
   * patchOrderItems — called on inject and on every shadow DOM mutation.
   *
   * Strategy: instead of fighting C:Hub's adoptedStyleSheets over .i-tl
   * positioning/alignment (which we cannot reliably win), we:
   *   1. Hide .i-tl via inline !important (unchallengeable by any stylesheet).
   *   2. Inject our own <span class="ltbn-item-label"> into each .o-i.
   *      C:Hub has no styles for .ltbn-item-label, so our CSS wins without
   *      any conflict at all.
   */
  function patchOrderItems(root) {
    // 1. Suppress C:Hub's original title element
    root.querySelectorAll('.order-body .i-tl').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });

    // 2. Insert our own label on items that don't have one yet
    root.querySelectorAll('.order-body .o-i:not([data-ltbn])').forEach(function (oi) {
      oi.setAttribute('data-ltbn', '1');
      var titleEl = oi.querySelector('.i-tl');
      if (!titleEl) return;
      var label = document.createElement('span');
      label.className = 'ltbn-item-label';
      label.textContent = titleEl.textContent;
      oi.appendChild(label);
    });
  }

  function inject(root) {
    if (root.querySelector('#ltbn-chub-styles')) return;
    var link = document.createElement('link');
    link.id = 'ltbn-chub-styles';
    link.rel = 'stylesheet';
    link.href = url;
    root.appendChild(link);

    // Watch for Vue re-renders (route changes, filter/sort updates)
    var mo = new MutationObserver(function () { patchOrderItems(root); });
    mo.observe(root, { childList: true, subtree: true });
    patchOrderItems(root);
  }

  function tryInject() {
    var hub = document.querySelector('accounts-hub');
    if (hub && hub.shadowRoot) {
      inject(hub.shadowRoot);
      return true;
    }
    return false;
  }

  if (!tryInject()) {
    var mo = new MutationObserver(function () {
      if (tryInject()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();


// ============================================================
// CONTACT FORM
// Only runs on pages containing .ltbn-cf-wrap.
// window.LTBN_CUSTOMER is set by the inline data <script> in
// sections/ltbn-contact-form.liquid before this defer'd script runs.
// ============================================================
(function () {
  if (!document.querySelector('.ltbn-cf-wrap')) return;

  const customer = window.LTBN_CUSTOMER;
  const reasonSelect = document.getElementById('cf-reason');
  const modifyFields = document.getElementById('modify-fields');
  const orderFields = document.getElementById('order-fields');
  const orderSelect = document.getElementById('cf-order');
  const orderNote = document.getElementById('cf-order-note');
  const orderSelectGeneral = document.getElementById('cf-order-general');
  const orderNoteGeneral = document.getElementById('cf-order-general-note');
  const submitBtn = document.getElementById('cf-submit');
  const successBox = document.getElementById('cf-success');
  const successEmail = document.getElementById('success-email');

  function populateSelect(select, noteEl, orders, emptyMsg) {
    orders.forEach(function (order) {
      const opt = document.createElement('option');
      opt.value = order.name;
      opt.textContent = order.name + ' — ' + order.date + ' (' + order.total + ')';
      select.appendChild(opt);
    });
    if (orders.length > 0) {
      noteEl.textContent = 'Showing your ' + orders.length + ' most recent order(s).';
    } else {
      const opt = document.createElement('option');
      opt.value = '';
      opt.textContent = emptyMsg;
      opt.disabled = true;
      select.appendChild(opt);
      noteEl.textContent = 'Please describe your order in the message field.';
    }
  }

  // Modify: exclude cancelled, restocked, and cannot-cancel orders
  const modifiableOrders = customer.orders.filter(function (o) {
    return !o.cancelled && o.status !== 'restocked' && !o.cannotCancel;
  });
  populateSelect(orderSelect, orderNote, modifiableOrders, 'No modifiable orders found on this account');

  // Damage / Help with order: exclude returned orders only
  const nonReturnedOrders = customer.orders.filter(function (o) {
    return !o.returned;
  });
  populateSelect(orderSelectGeneral, orderNoteGeneral, nonReturnedOrders, 'No orders found on this account');

  // Show/hide order panels based on selected reason
  reasonSelect.addEventListener('change', function () {
    modifyFields.classList.toggle('visible', this.value === 'modify');
    orderFields.classList.toggle('visible', this.value === 'damage' || this.value === 'help');
  });

  function validate() {
    const name = document.getElementById('cf-name').value.trim();
    const email = document.getElementById('cf-email').value.trim();
    const reason = reasonSelect.value;
    const message = document.getElementById('cf-message').value.trim();
    if (!name || !email || !reason || !message) return false;
    if (reason === 'modify') {
      const orderVal = orderSelect.value;
      const modType = document.querySelector('input[name="contact[mod_type]"]:checked');
      if (!orderVal || !modType) return false;
    }
    return true;
  }

  submitBtn.addEventListener('click', async function () {
    if (!validate()) {
      submitBtn.textContent = 'Please fill all required fields';
      submitBtn.style.background = 'var(--ltbn-error-bg)';
      setTimeout(function () {
        submitBtn.textContent = 'Send message';
        submitBtn.style.background = '';
      }, 2500);
      return;
    }

    const name = document.getElementById('cf-name').value.trim();
    const email = document.getElementById('cf-email').value.trim();
    const phone = document.getElementById('cf-phone').value.trim();
    const reason = reasonSelect.value;
    const message = document.getElementById('cf-message').value.trim();
    const order = orderSelect.value || '';
    const orderGeneral = orderSelectGeneral.value || '';
    const modTypeEl = document.querySelector('input[name="contact[mod_type]"]:checked');
    const modType = modTypeEl ? modTypeEl.value : '';

    const reasonLabels = {
      general: 'General inquiry',
      modify: 'Modify an order',
      billing: 'Billing question',
      help: 'Help with order',
      damage: 'Damage report'
    };

    let body = 'Reason: ' + (reasonLabels[reason] || reason) + '\n';
    if (reason === 'modify') {
      body += 'Order: ' + order + '\n';
      body += 'Modification type: ' + modType + '\n';
    } else if ((reason === 'damage' || reason === 'help') && orderGeneral) {
      body += 'Order: ' + orderGeneral + '\n';
    }
    if (phone) body += 'Phone: ' + phone + '\n';
    body += '\n' + message;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    try {
      const captchaEl = document.querySelector('.h-captcha');
      const widgetId = captchaEl ? captchaEl.getAttribute('data-hcaptcha-widget-id') : null;
      const captchaToken = widgetId && window.hcaptcha
        ? (await hcaptcha.execute(widgetId, { async: true })).response
        : '';

      const formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      formData.append('contact[name]', name);
      formData.append('contact[email]', email);
      formData.append('contact[body]', body);
      if (captchaToken) formData.append('h-captcha-response', captchaToken);

      const res = await fetch('/contact#ltbn-cf', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok || res.redirected) {
        document.querySelector('.ltbn-cf-card').style.display = 'none';
        document.querySelector('.ltbn-submit-wrap').style.display = 'none';
        successEmail.textContent = email;
        successBox.classList.add('visible');
      } else {
        throw new Error('Send failed');
      }
    } catch {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send failed — try again';
      submitBtn.style.background = 'var(--ltbn-error-bg)';
      setTimeout(function () {
        submitBtn.textContent = 'Send message';
        submitBtn.style.background = '';
      }, 3000);
    }
  });
})();


// ============================================================
// SECURE DOCUMENT UPLOAD
// Only runs on pages containing .ltbn-upload-wrapper.
// window.LTBN_UPLOAD is set by the inline data <script> in
// sections/ltbn-secure-upload.liquid before this defer'd script runs.
// ============================================================
(function () {
  if (!document.querySelector('.ltbn-upload-wrapper')) return;

  const cfg = window.LTBN_UPLOAD;
  const state = { tax: null, photo: null, submitting: false };
  let locked = false;

  // Reveal upload UI when trigger button is clicked
  const triggerBtn = document.getElementById('ltbn-trigger-btn');
  if (triggerBtn) {
    triggerBtn.addEventListener('click', function () {
      document.getElementById('ltbn-trigger-wrap').style.display = 'none';
      document.getElementById('ltbn-upload-ui').style.display = 'block';
    });
  }

  // Wire up drag-and-drop and file input for each upload zone
  [
    { zoneId: 'zone-tax', inputId: 'input-tax', type: 'tax' },
    { zoneId: 'zone-id',  inputId: 'input-id',  type: 'photo' }
  ].forEach(function (zone) {
    const zoneEl  = document.getElementById(zone.zoneId);
    const inputEl = document.getElementById(zone.inputId);
    const chooseBtn = zoneEl.querySelector('.ltbn-zone-btn');

    chooseBtn.addEventListener('click', function () { if (locked) return; inputEl.click(); });

    inputEl.addEventListener('change', function () {
      if (locked) return;
      if (this.files[0]) processFile(this.files[0], zone.zoneId, zone.type);
    });

    zoneEl.addEventListener('dragover', function (e) {
      if (locked) return;
      e.preventDefault();
      zoneEl.classList.add('dragover');
    });
    zoneEl.addEventListener('dragleave', function () {
      if (locked) return;
      zoneEl.classList.remove('dragover');
    });
    zoneEl.addEventListener('drop', function (e) {
      e.preventDefault();
      if (locked) return;
      zoneEl.classList.remove('dragover');
      const f = e.dataTransfer.files[0];
      if (f) processFile(f, zone.zoneId, zone.type);
    });
  });

  // Wire up submit button
  const submitBtn = document.getElementById('ltbn-submit-btn');
  submitBtn.addEventListener('click', handleSubmit);

  // Lock zones if docs are already on file or tax exempt is verified
  function lockZones(verified) {
    locked = true;
    const btnText = verified ? '✓ Verified' : '✓ On File';
    ['zone-tax', 'zone-id'].forEach(function (id) {
      const z = document.getElementById(id);
      z.classList.add('ltbn-zone--locked');
      z.querySelector('.ltbn-zone-btn').textContent = btnText;
    });
    submitBtn.disabled = true;
    document.getElementById('ltbn-status-msg').textContent = verified
      ? 'Tax exemption verified — no action needed'
      : 'Documents already on file — no action needed';
  }

  function unlockZones() {
    locked = false;
    ['zone-tax', 'zone-id'].forEach(function (id) {
      const z = document.getElementById(id);
      z.classList.remove('ltbn-zone--locked');
      z.querySelector('.ltbn-zone-btn').textContent = 'Choose File';
    });
    checkReady();
  }

  if (cfg.taxExempt || (cfg.taxUploaded && cfg.idUploaded)) {
    lockZones(cfg.taxExempt);
  }

  const replaceDocsBtn = document.getElementById('ltbn-replace-docs');
  if (replaceDocsBtn) {
    replaceDocsBtn.addEventListener('click', function () {
      document.getElementById('ltbn-upload-ui').style.display = 'block';
      unlockZones();
    });
  }

  const deleteDocsBtn = document.getElementById('ltbn-delete-docs');
  if (deleteDocsBtn) {
    deleteDocsBtn.addEventListener('click', async function () {
      if (!confirm('Are you sure you want to delete your uploaded documents? You will need to re-upload them to complete tax exemption verification.')) return;
      deleteDocsBtn.disabled = true;
      deleteDocsBtn.textContent = 'Deleting...';
      try {
        const res = await fetch(cfg.workerUrl + '/reset-docs', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId: cfg.id, fileType: 'both' })
        });
        if (!res.ok) throw new Error('Server error');
        window.location.reload();
      } catch (err) {
        deleteDocsBtn.disabled = false;
        deleteDocsBtn.textContent = 'Delete Documents';
        alert('Could not delete documents. Please try again.');
      }
    });
  }

  function processFile(file, zoneId, type) {
    if (file.size > 10 * 1024 * 1024) {
      alert('File exceeds the 10MB limit. Please choose a smaller file.');
      return;
    }

    state[type] = file;
    const zone = document.getElementById(zoneId);
    zone.classList.remove('dragover');
    zone.classList.add('uploaded');

    let badge = zone.querySelector('.ltbn-uploaded-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'ltbn-uploaded-badge';
      badge.textContent = 'READY';
      zone.appendChild(badge);
    }

    const suffix = zoneId === 'zone-tax' ? 'tax' : 'id';
    document.getElementById('name-' + suffix).textContent = file.name;
    checkReady();
  }

  function checkReady() {
    const ready = !!(state.tax || state.photo);
    submitBtn.disabled = !ready;
    document.getElementById('ltbn-status-msg').textContent = ready
      ? 'Ready to submit'
      : 'Select a document to continue';
  }

  async function uploadFile(file, type) {
    const suffix = type === 'tax' ? 'tax' : 'id';
    const progWrap = document.getElementById('prog-' + suffix);
    const progBar  = document.getElementById('bar-' + suffix);
    progWrap.style.display = 'block';
    progBar.style.width = '10%';

    try {
      // Step 1: Request presigned URL from Cloudflare Worker
      const presignRes = await fetch(cfg.workerUrl + '/presign', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId:    cfg.id,
          customerEmail: cfg.email,
          fileType:      type,
          fileName:      file.name,
          mimeType:      file.type
        })
      });

      if (!presignRes.ok) throw new Error('Failed to get upload authorization.');
      const { uploadUrl, fileKey } = await presignRes.json();

      progBar.style.width = '35%';

      // Step 2: Upload directly to storage via presigned URL
      const uploadRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file
      });

      if (!uploadRes.ok) throw new Error('Upload to secure storage failed.');

      progBar.style.width = '80%';

      // Step 3: Confirm upload to Worker (writes customer metafield)
      const confirmRes = await fetch(cfg.workerUrl + '/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: cfg.id,
          fileType:   type,
          fileKey:    fileKey
        })
      });

      if (!confirmRes.ok) throw new Error('Upload confirmation failed.');

      progBar.style.width = '100%';
      return true;

    } catch (err) {
      progWrap.style.display = 'none';
      throw err;
    }
  }

  async function handleSubmit() {
    if (state.submitting) return;
    state.submitting = true;

    const statusEl = document.getElementById('ltbn-status-msg');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Uploading...';
    statusEl.textContent = 'Securely uploading your documents...';
    statusEl.className = 'ltbn-status-msg';

    try {
      await Promise.all([
        state.tax   && uploadFile(state.tax,   'tax'),
        state.photo && uploadFile(state.photo, 'photo')
      ].filter(Boolean));

      submitBtn.textContent = 'Documents Submitted';
      statusEl.textContent = 'Your documents have been securely uploaded. LTBN staff will review and update your account within 1-2 business days.';
      statusEl.className = 'ltbn-status-msg success';

    } catch (err) {
      submitBtn.textContent = 'Submit Documents';
      submitBtn.disabled = false;
      state.submitting = false;
      statusEl.textContent = 'Something went wrong: ' + err.message + ' Please try again or contact us.';
      statusEl.style.color = 'var(--ltbn-error-color)';
    }
  }
})();


// ============================================================
// CART CHECKOUT FIELDS — Validation + cart attribute writes
// (snippets/cart-ltbn-fields.liquid)
// Only runs on pages containing #ltbn-checkout-fields.
// window.LTBN_CART is set by an inline data <script> in the
// snippet before this defer'd script runs.
// ============================================================
(function () {
  'use strict';
  if (!document.getElementById('ltbn-checkout-fields')) return;

  const CART_UPDATE_URL = '/cart/update.js';
  const LTBN_TAX_OVERRIDE = window.LTBN_CART && window.LTBN_CART.taxOverride;
  const isFilmCheckbox  = document.getElementById('ltbn-is-film-production');
  const productionWrap  = document.getElementById('ltbn-production-name-wrap');
  const companyInput    = document.getElementById('ltbn-company');
  const companyError    = document.getElementById('ltbn-company-error');
  const productionInput = document.getElementById('ltbn-production-name');
  const setInput        = document.getElementById('ltbn-set-name');
  const taxCheckbox     = document.getElementById('ltbn-tax-excempt');
  const taxLoginNotice  = document.getElementById('ltbn-tax-login-notice');
  const termsCheckbox   = document.getElementById('ltbn-terms-accepted');
  const termsError      = document.getElementById('ltbn-terms-error');
  const tncGroup        = document.getElementById('ltbn-tnc-group');
  const prodNameError   = document.getElementById('ltbn-prod-name-error');
  const filmGroup       = document.getElementById('ltbn-film-group');
  const conflictError   = document.getElementById('ltbn-pickup-conflict-error');
  const conflictGroup   = document.getElementById('ltbn-pickup-conflict-group');

  async function checkDateConflict(shake) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const pickupDates = [...new Set(
      cart.items.map(item => item.properties?.['Pickup Date']).filter(Boolean)
    )];
    const returnDates = [...new Set(
      cart.items.map(item => item.properties?.['Return Date']).filter(Boolean)
    )];

    if (pickupDates.length > 1 || returnDates.length > 1) {
      conflictError.textContent =
        'Your cart contains rental items with different pickup or return dates. ' +
        'Please place separate orders for each set of dates.';
      conflictError.style.display = 'block';
      if (shake) {
        conflictGroup.classList.remove('ltbn-shake');
        void conflictGroup.offsetWidth;
        conflictGroup.classList.add('ltbn-shake');
        conflictGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    }

    conflictError.style.display = 'none';
    return false;
  }

  checkDateConflict(false);

  isFilmCheckbox.addEventListener('change', function () {
    productionWrap.style.display = this.checked ? 'block' : 'none';
    if (this.checked) {
      productionInput.setAttribute('required', '');
    } else {
      productionInput.removeAttribute('required');
    }
    updateCartAttributes();
  });

  // A guest (or anyone not currently logged in) has no Shopify customer ID yet, so
  // checkout can't flip their tax_exempt flag before Shopify's hosted login takes
  // over outside our theme's JS. Rather than let them reach checkout and get
  // charged tax anyway, warn them up front and block checkout until they log in.
  function updateTaxGuestNotice() {
    if (!taxCheckbox || (window.LTBN_CART && window.LTBN_CART.customerId)) return;
    const show = taxCheckbox.checked;
    if (taxLoginNotice) taxLoginNotice.style.display = show ? 'block' : 'none';
    document.querySelectorAll(
      '[name="checkout"], [href="/checkout"], button[type="submit"][name="checkout"], .cart__checkout-button, #checkout'
    ).forEach(btn => {
      if (show) {
        btn.disabled = true;
      } else if (!(window.LTBN_CART && window.LTBN_CART.orderBlocked)) {
        btn.disabled = false;
      }
    });
  }

  async function updateCartAttributes() {
    const isTaxExempt = LTBN_TAX_OVERRIDE || (taxCheckbox ? (taxCheckbox.checked ? 'Yes' : 'No') : 'No');
    const isFilm      = isFilmCheckbox.checked;
    const company     = companyInput.value.trim() || '';
    const prodName    = isFilm ? (productionInput.value.trim() || '') : '';
    const setName     = isFilm ? (setInput.value.trim() || '') : '';

    const attrs = {
      'Film/TV Production':    isFilm ? 'Yes' : 'No',
      'Company':               company,
      'Production Name':       prodName,
      'Set Name':              setName,
      'Tax Exempt':            isTaxExempt,
      'Rental Terms Accepted': termsCheckbox.checked ? 'Yes' : 'No'
    };

    try {
      await fetch(CART_UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    } catch (e) {
      console.error('[LTBN] Cart update failed:', e);
    }
  }

  async function validateAndCheckout(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (window.LTBN_CART && window.LTBN_CART.orderBlocked) {
      const notice = document.getElementById('ltbn-order-blocked-notice');
      if (notice) {
        notice.style.display = 'block';
        notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    let blocked = false;

    if (await checkDateConflict(true)) return;

    if (isFilmCheckbox.checked && !productionInput.value.trim()) {
      prodNameError.style.display = 'block';
      productionInput.style.borderColor = 'var(--ltbn-error-border)';
      if (!blocked) {
        filmGroup.classList.remove('ltbn-shake');
        void filmGroup.offsetWidth;
        filmGroup.classList.add('ltbn-shake');
        filmGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      blocked = true;
    } else {
      prodNameError.style.display = 'none';
      productionInput.style.borderColor = '';
    }

    if (!termsCheckbox.checked) {
      termsError.style.display = 'block';
      tncGroup.classList.remove('ltbn-shake');
      void tncGroup.offsetWidth;
      tncGroup.classList.add('ltbn-shake');
      if (!blocked) tncGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    termsError.style.display = 'none';
    if (!blocked) {
      await updateCartAttributes();

      // If a logged-in customer is self-declaring tax exempt (not already admin-verified),
      // flip customer.tax_exempt = true in Shopify before checkout loads so that
      // Shopify's native checkout calculates $0 tax. Staff still must verify docs
      // before the order is processed; they can revoke via the admin extension if needed.
      const isSelfDeclaring = taxCheckbox && taxCheckbox.checked
        && !LTBN_TAX_OVERRIDE
        && window.LTBN_CART && window.LTBN_CART.customerId;

      if (isSelfDeclaring) {
        try {
          await fetch(window.LTBN_CART.workerUrl + '/set-customer-tax-exempt', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shopify_customer_id: window.LTBN_CART.customerId })
          });
        } catch (e) {
          // Non-blocking — proceed to checkout regardless; worst case Shopify charges tax
          console.warn('[LTBN] Could not set tax exempt before checkout:', e);
        }
      }

      window.location.href = '/checkout';
    }
  }

  function attachCheckoutListeners() {
    document.querySelectorAll(
      '[name="checkout"], [href="/checkout"], button[type="submit"][name="checkout"], .cart__checkout-button, #checkout'
    ).forEach(btn => {
      btn.addEventListener('click', validateAndCheckout, true);
    });
  }

  if (taxCheckbox) taxCheckbox.addEventListener('change', function () {
    updateCartAttributes();
    updateTaxGuestNotice();
  });
  updateTaxGuestNotice();
  termsCheckbox.addEventListener('change', function () {
    if (this.checked) termsError.style.display = 'none';
    updateCartAttributes();
  });
  companyInput.addEventListener('input', function () {
    updateCartAttributes();
  });
  productionInput.addEventListener('input', function () {
    if (this.value.trim()) {
      prodNameError.style.display = 'none';
      this.style.borderColor = '';
    }
    updateCartAttributes();
  });
  setInput.addEventListener('input', function () {
    updateCartAttributes();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachCheckoutListeners);
  } else {
    attachCheckoutListeners();
  }

  new MutationObserver(attachCheckoutListeners).observe(document.body, {
    childList: true,
    subtree: true
  });

  if (window.LTBN_CART && window.LTBN_CART.orderBlocked) {
    const notice = document.getElementById('ltbn-order-blocked-notice');
    if (notice) notice.style.display = 'block';
    document.querySelectorAll(
      '[name="checkout"], button[type="submit"][name="checkout"], .cart__checkout-button, #checkout'
    ).forEach(btn => { btn.disabled = true; });
  }

})();


// ============================================================
// CART CHECKOUT FIELDS — Terms modal
// (snippets/cart-ltbn-fields.liquid)
// ============================================================
(function () {
  'use strict';
  if (!document.getElementById('ltbn-checkout-fields')) return;

  let termsHtmlCache = null;

  const openBtn    = document.getElementById('ltbn-open-terms-btn');
  const statusSpan = document.getElementById('ltbn-terms-status');
  const checkbox   = document.getElementById('ltbn-terms-accepted');
  const termsError = document.getElementById('ltbn-terms-error');
  const dialogComp = document.getElementById('ltbn-terms-dialog-component');
  const body       = document.getElementById('ltbn-terms-body');
  const spinner    = document.getElementById('ltbn-terms-spinner');
  const content    = document.getElementById('ltbn-terms-content');
  const loadError  = document.getElementById('ltbn-terms-load-error');
  const acceptBtn  = document.getElementById('ltbn-accept-terms-btn');
  const closeBtn   = document.getElementById('ltbn-terms-close-btn');
  const scrollHint = document.getElementById('ltbn-scroll-hint');

  function checkScrolledToBottom() {
    const atBottom = body.scrollTop + body.clientHeight >= body.scrollHeight - 60;
    acceptBtn.disabled = !atBottom;
    if (atBottom) scrollHint.classList.add('ltbn-hint-done');
  }

  async function loadTerms() {
    if (termsHtmlCache !== null) { renderTerms(termsHtmlCache); return; }

    spinner.style.display = 'flex';
    content.style.display = 'none';
    loadError.style.display = 'none';
    acceptBtn.disabled = true;
    scrollHint.classList.remove('ltbn-hint-done');

    try {
      const res = await fetch('/pages/terms.json');
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      termsHtmlCache = data.page.body_html || '';
      renderTerms(termsHtmlCache);
    } catch (e) {
      spinner.style.display = 'none';
      loadError.style.display = 'block';
    }
  }

  function renderTerms(html) {
    content.innerHTML = html;
    spinner.style.display = 'none';
    content.style.display = 'block';
    acceptBtn.disabled = true;
    scrollHint.classList.remove('ltbn-hint-done');
    body.scrollTop = 0;
    requestAnimationFrame(checkScrolledToBottom);
  }

  body.addEventListener('scroll', checkScrolledToBottom);
  closeBtn.addEventListener('click', () => dialogComp.closeDialog());

  acceptBtn.addEventListener('click', () => {
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change'));
    statusSpan.textContent = '✓ Accepted';
    termsError.style.display = 'none';
    dialogComp.closeDialog();
  });

  customElements.whenDefined('dialog-component').then(() => {
    openBtn.addEventListener('click', () => { dialogComp.showDialog(); loadTerms(); });
  });

})();


// ============================================================
// ACCOUNT POPOVER — rename "Orders" → "My Account", hide Profile button
// CSS already hides the 2nd list item; JS renames the 1st link's text/icon
// and uses a MutationObserver to survive morph.js re-renders.
// ============================================================
(function () {
  const PERSON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="6.5" r="2.75" stroke="currentColor" stroke-width="var(--icon-stroke-width)"></circle>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="m5.172 14.591-.437.786a.588.588 0 0 0 .514.873h9.502a.588.588 0 0 0 .514-.873l-.437-.786a5.523 5.523 0 0 0-9.656 0"></path>
  </svg>`;

  let observer = null;

  function patchAccountPopover() {
    const panel = document.getElementById('account-popover');
    if (!panel) return;

    // Disconnect before mutating to avoid triggering ourselves
    if (observer) observer.disconnect();

    const firstLink = panel.querySelector('.account-actions__list-item:first-child .account-actions__link');
    if (firstLink) {
      const icon = firstLink.querySelector('.account-actions__icon');
      if (icon) icon.innerHTML = PERSON_SVG;

      [...firstLink.childNodes]
        .filter(n => n.nodeType === Node.TEXT_NODE)
        .forEach(n => (n.textContent = ' My Account'));
    }

    const secondItem = panel.querySelector('.account-actions__list-item:nth-child(2)');
    if (secondItem) secondItem.style.display = 'none';

    // Reconnect to catch future morph.js re-renders
    if (observer) observer.observe(panel, { childList: true, subtree: true });
  }

  function init() {
    const panel = document.getElementById('account-popover');
    if (!panel) return;
    observer = new MutationObserver(patchAccountPopover);
    patchAccountPopover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================================
// BUY VARIANT PICKUP DATE SELECTOR
// Shows a date picker when the "BUY" variant is selected in the
// PRP rental widget so customers can specify a sign pickup date.
// The input uses class rw-extra-input so PRP preserves it across
// widget re-renders and includes it in the cart add payload as
// a line item property (properties[Pickup Date]).
// ============================================================
(function () {
  var PICKER_ID = 'ltbn-buy-pickup';
  var isBuyActive = false;
  var exclusionsOriginalParent = null;
  var exclusionsOriginalNext = null;

  function createPicker() {
    var wrapper = document.createElement('div');
    wrapper.id = PICKER_ID;
    wrapper.style.display = 'none';

    var row = document.createElement('div');
    row.id = 'ltbn-buy-pickup-row';

    var label = document.createElement('label');
    label.htmlFor = 'ltbn-buy-pickup-date';
    label.className = 'sbd-widget__label';
    label.textContent = 'Pickup Date';

    var input = document.createElement('input');
    input.type = 'date';
    input.id = 'ltbn-buy-pickup-date';
    input.className = 'sbd-widget__input';
    input.min = getMinPickupDate();
    input.addEventListener('click', function () {
      try { this.showPicker(); } catch (e) {}
    });

    // Holds the formatted value PRP submits as the line item property
    var hiddenValue = document.createElement('input');
    hiddenValue.type = 'text';
    hiddenValue.id = 'ltbn-buy-pickup-value';
    hiddenValue.name = 'properties[Pickup Date]';
    hiddenValue.className = 'rw-extra-input';
    hiddenValue.style.cssText = 'display:none;';

    input.addEventListener('change', function () {
      var error = document.getElementById('ltbn-buy-pickup-error');
      if (!this.value) { hiddenValue.value = ''; return; }
      var d = new Date(this.value + 'T00:00:00');
      if (d.getDay() === 0 || d.getDay() === 6) {
        this.value = '';
        hiddenValue.value = '';
        if (error) {
          error.textContent = 'Please select a weekday (Mon–Fri).';
          error.style.display = 'block';
        }
        return;
      }
      if (error) error.style.display = 'none';
      hiddenValue.value = d.toLocaleDateString('en-GB', {
        weekday: 'short', day: '2-digit', month: 'short', year: 'numeric'
      });
    });

    var error = document.createElement('p');
    error.id = 'ltbn-buy-pickup-error';
    error.textContent = 'Please select a pickup date before adding to cart.';

    row.appendChild(label);
    row.appendChild(input);
    row.appendChild(hiddenValue);
    wrapper.appendChild(row);
    wrapper.appendChild(error);
    return wrapper;
  }

  function insertPicker() {
    if (document.getElementById(PICKER_ID)) return;
    var anchor = document.querySelector('.rw-exclusions-info');
    if (!anchor) return;
    exclusionsOriginalParent = anchor.parentNode;
    exclusionsOriginalNext = anchor.nextSibling;
    var picker = createPicker();
    exclusionsOriginalParent.insertBefore(picker, anchor);
  }

  function showPicker() {
    insertPicker();
    var picker = document.getElementById(PICKER_ID);
    if (picker) picker.style.display = 'block';
    var row = document.getElementById('ltbn-buy-pickup-row');
    var exclusions = document.querySelector('.rw-exclusions-info');
    if (row && exclusions && !row.contains(exclusions)) {
      row.appendChild(exclusions);
    }
  }

  function hidePicker() {
    var picker = document.getElementById(PICKER_ID);
    if (!picker) return;
    var exclusions = document.querySelector('.rw-exclusions-info');
    if (exclusions && exclusionsOriginalParent) {
      exclusionsOriginalParent.insertBefore(exclusions, exclusionsOriginalNext);
    }
    picker.style.display = 'none';
    var input = document.getElementById('ltbn-buy-pickup-date');
    if (input) input.value = '';
    var hiddenValue = document.getElementById('ltbn-buy-pickup-value');
    if (hiddenValue) hiddenValue.value = '';
    var error = document.getElementById('ltbn-buy-pickup-error');
    if (error) error.style.display = 'none';
  }

  function getMinPickupDate() {
    var date = new Date();
    var added = 0;
    while (added < 2) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date.toISOString().split('T')[0];
  }

  function isBuyVariant(variant) {
    return variant && /^buy$/i.test((variant.title || '').trim());
  }

  document.addEventListener('prp::variant::changed', function (e) {
    var variant = e.detail && e.detail.variant;
    isBuyActive = isBuyVariant(variant);
    if (isBuyActive) {
      showPicker();
    } else {
      hidePicker();
    }
  });

  document.addEventListener('prp::cart:added', function (e) {
    if (!isBuyActive) return;
    var hiddenValue = document.getElementById('ltbn-buy-pickup-value');
    if (hiddenValue && hiddenValue.value) return;
    var whenPrevented = e.detail && e.detail.whenPrevented;
    if (whenPrevented) {
      if (whenPrevented.preventRedirect) whenPrevented.preventRedirect();
      if (whenPrevented.resetButton) whenPrevented.resetButton();
    }
    var error = document.getElementById('ltbn-buy-pickup-error');
    if (error) error.style.display = 'block';
  });

  // Handle case where BUY variant is already selected on page load.
  // PRP renders asynchronously so we observe the DOM for its container.
  function checkInitialVariant() {
    var checkedInput = document.querySelector('.rw-variant-picker-container input[type="radio"]:checked');
    if (!checkedInput) return;
    var label = checkedInput.closest('label') || document.querySelector('label[for="' + checkedInput.id + '"]');
    var title = (checkedInput.value || (label && label.textContent) || '').trim();
    if (/^buy$/i.test(title)) {
      isBuyActive = true;
      showPicker();
    }
  }

  function init() {
    var variantContainer = document.querySelector('.rw-variant-picker-container');
    if (variantContainer) {
      checkInitialVariant();
      return;
    }
    var observer = new MutationObserver(function () {
      if (document.querySelector('.rw-variant-picker-container')) {
        observer.disconnect();
        checkInitialVariant();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ============================================================
// STRIPE PAYMENT PAGE
// Only runs on pages containing .ltbn-payment-wrapper.
// window.LTBN_PAYMENT is set by the inline data <script> in
// sections/ltbn-payment.liquid before this defer'd script runs.
//
// Uses Stripe's deferred intent pattern — the PaymentIntent is
// created only when the customer clicks Pay, so browsing the
// page never creates incomplete PIs in Stripe.
// ============================================================
(function () {
  if (!document.querySelector('.ltbn-payment-wrapper')) return;

  var W = window.LTBN_PAYMENT;
  var stripeInstance = null;
  var currentElements = null;
  var currentOrderId = null;
  var currentAmountCents = 0;
  var currentPaymentMethodTypes = null;

  var APPEARANCE = {
    theme: 'night',
    variables: {
      colorPrimary:     '#00a6ff',
      colorBackground:  '#0a0a0a',
      colorText:        '#e8e8e8',
      colorDanger:      '#ff3355',
      fontFamily:       '"DM Sans", sans-serif',
      borderRadius:     '5px',
      spacingUnit:      '4px',
    },
    rules: {
      '.Input': {
        backgroundColor: '#141414',
        border:          '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow:       'none',
      },
      '.Input:focus': {
        border:    '1px solid rgba(255, 255, 255, 0.35)',
        boxShadow: 'none',
      },
      '.Label': {
        color:         'rgba(255, 255, 255, 0.45)',
        fontSize:      '11px',
        fontWeight:    '700',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
      },
    }
  };

  function fmt(n) {
    return '$' + parseFloat(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function post(path, data) {
    return fetch(W.workerUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function renderOrderSummary(order) {
    // For tax-exempt customers always charge the subtotal regardless of what Shopify
    // calculated on the order — handles the race condition where Shopify's checkout
    // may have added tax before the tax_exempt flag propagated. For non-exempt customers
    // use Shopify's calculated total so we're never applying a hardcoded rate.
    var subtotalCents = order.subtotalCents;
    var amountCents   = W.taxExempt ? order.subtotalCents : order.totalPriceCents;
    var taxCents      = W.taxExempt ? 0 : order.totalTaxCents;
    var subtotal = subtotalCents / 100;
    var total    = amountCents   / 100;
    var tax      = taxCents      / 100;

    var html = order.lineItems.map(function (item) {
      var label = item.quantity > 1 ? item.title + ' \xd7' + item.quantity : item.title;
      return '<div class="ltbn-order-row"><span>' + label + '</span><span>' + fmt(item.priceCents * item.quantity / 100) + '</span></div>';
    }).join('');

    html += '<div class="ltbn-order-divider"></div>';
    html += '<div class="ltbn-order-row"><span>Subtotal</span><span>' + fmt(subtotal) + '</span></div>';
    if (taxCents > 0) {
      html += '<div class="ltbn-order-row"><span>Sales Tax</span><span>' + fmt(tax) + '</span></div>';
    }
    html += '<div class="ltbn-order-divider"></div>';
    html += '<div class="ltbn-order-row ltbn-order-total"><span>Total</span><span>' + fmt(total) + '</span></div>';

    document.getElementById('ltbn-order-summary').innerHTML = html;
    return amountCents;
  }

  async function loadOrderPayment(order) {
    currentOrderId = String(order.id);
    currentAmountCents = renderOrderSummary(order);

    document.getElementById('ltbn-order-details').style.display = '';
    document.getElementById('ltbn-element-error').style.display = 'none';
    document.getElementById('ltbn-pay-inline-error').textContent = '';
    document.getElementById('ltbn-element-loading').style.display = '';
    document.getElementById('ltbn-element-ready').style.display = 'none';

    if (!stripeInstance) stripeInstance = Stripe(W.stripePk);

    // Clear any previously mounted element before recreating
    if (currentElements) {
      document.getElementById('payment-element').innerHTML = '';
      currentElements = null;
    }

    // Worker resolves the order's ltbn.payment_method metafield (falling back to the checkout gateway)
    currentPaymentMethodTypes = null;
    try {
      var gwRes = await post('/get-order-gateway', { shopify_order_id: currentOrderId });
      if (gwRes.ok) {
        var gwData = await gwRes.json();
        currentPaymentMethodTypes = gwData.payment_method_types || null;
      }
    } catch (e) {}

    var elementsConfig = {
      mode:               'payment',
      amount:             currentAmountCents,
      currency:           'usd',
      setup_future_usage: 'off_session',
      appearance:         APPEARANCE
    };
    if (currentPaymentMethodTypes) {
      elementsConfig.payment_method_types = currentPaymentMethodTypes;
    }

    currentElements = stripeInstance.elements(elementsConfig);
    currentElements.create('payment').mount('#payment-element');

    document.getElementById('ltbn-element-loading').style.display = 'none';
    document.getElementById('ltbn-element-ready').style.display = '';
  }

  function wirePayButton() {
    document.getElementById('ltbn-pay-btn').addEventListener('click', async function () {
      var btn = document.getElementById('ltbn-pay-btn');
      var errEl = document.getElementById('ltbn-pay-inline-error');
      btn.disabled = true;
      btn.textContent = 'Processing…';
      errEl.textContent = '';

      // Step 1: Validate the element before making any server calls
      var submitResult = await currentElements.submit();
      if (submitResult.error) {
        errEl.textContent = submitResult.error.message;
        btn.disabled = false;
        btn.textContent = 'Pay Now';
        return;
      }

      // Step 2: Get/create Stripe customer
      var custRes;
      try {
        custRes = await post('/get-or-create-stripe-customer', {
          shopify_customer_id: W.customerId,
          email: W.email,
          name: W.name
        });
        if (!custRes.ok) throw new Error();
      } catch (e) {
        errEl.textContent = 'Failed to initialize payment. Please try again.';
        btn.disabled = false;
        btn.textContent = 'Pay Now';
        return;
      }
      var custData = await custRes.json();

      // Step 3: Create PaymentIntent — only happens on actual submit
      var piRes;
      try {
        piRes = await post('/create-payment-intent', {
          shopify_order_id:       currentOrderId,
          amount_cents:           currentAmountCents,
          stripe_customer_id:     custData.stripe_customer_id
        });
        if (!piRes.ok) throw new Error();
      } catch (e) {
        errEl.textContent = 'Failed to prepare payment. Please try again.';
        btn.disabled = false;
        btn.textContent = 'Pay Now';
        return;
      }
      var piData = await piRes.json();

      // Step 4: Confirm — clientSecret passed here, not at elements() time
      var result = await stripeInstance.confirmPayment({
        elements:     currentElements,
        clientSecret: piData.client_secret,
        confirmParams: {
          return_url: window.location.origin + window.location.pathname + '?order_id=' + currentOrderId
        },
        redirect: 'if_required'
      });

      if (result.error) {
        errEl.textContent = result.error.message;
        btn.disabled = false;
        btn.textContent = 'Pay Now';
        return;
      }

      // Step 5: Update Shopify order (webhook also handles this server-side)
      try {
        await post('/confirm-payment', {
          shopify_order_id:          currentOrderId,
          stripe_payment_intent_id:  result.paymentIntent.id
        });
      } catch (e) {}

      document.getElementById('ltbn-pay-main').style.display = 'none';
      document.getElementById('ltbn-pay-success').style.display = '';
    });
  }

  function init() {
    var params = new URLSearchParams(window.location.search);

    // Returned from 3D Secure redirect
    if (params.get('redirect_status') === 'succeeded') {
      var piId = params.get('payment_intent');
      var oidR = params.get('order_id');
      if (piId && oidR) {
        post('/confirm-payment', { shopify_order_id: oidR, stripe_payment_intent_id: piId })
          .catch(function () {});
      }
      document.getElementById('ltbn-pay-success').style.display = '';
      return;
    }

    var orders = W.orders || [];

    if (orders.length === 0) {
      document.getElementById('ltbn-pay-none').style.display = '';
      return;
    }

    // Populate dropdown
    var select = document.getElementById('ltbn-order-select');
    orders.forEach(function (order) {
      var opt = document.createElement('option');
      opt.value = String(order.id);
      var itemCount = order.lineItems.length;
      var dueCents = W.taxExempt ? order.subtotalCents : order.totalPriceCents;
      opt.textContent = order.name + ' — ' + order.createdAt + ' — ' + fmt(dueCents / 100) + ' (' + (itemCount === 1 ? '1 item' : itemCount + ' items') + ')';
      select.appendChild(opt);
    });

    document.getElementById('ltbn-pay-main').style.display = '';

    // Wire pay button once — uses currentOrderId / currentAmountCents closures
    wirePayButton();

    // Pre-select from URL param
    var urlOrderId = params.get('order_id');
    if (urlOrderId) {
      var preselect = orders.find(function (o) { return String(o.id) === urlOrderId; });
      if (preselect) {
        select.value = urlOrderId;
        loadOrderPayment(preselect);
      }
    }

    select.addEventListener('change', function () {
      var selectedId = this.value;
      if (!selectedId) {
        document.getElementById('ltbn-order-details').style.display = 'none';
        return;
      }
      var order = orders.find(function (o) { return String(o.id) === selectedId; });
      if (order) loadOrderPayment(order);
    });
  }

  try {
    init();
  } catch (err) {
    console.error('LTBN Payment init error:', err);
  }
})();
